import VideoPlayer from './VideoPlayer';
import VideoPlayerMulti from './VideoPlayerMulti';

export { VideoPlayer };
export { VideoPlayerMulti };

export default VideoPlayer;
